import { BRAND_REVIEWS_GRANULAR_ATTRIBUTES_DISPLAY_XP_250306 } from "@faire/web-api--source/indigofair/settings/BRAND_REVIEWS_GRANULAR_ATTRIBUTES_DISPLAY_XP_250306";

import {
  useReviewsHoldoutGatedAssignSettingEffect,
  useReviewsHoldoutGatedSetting,
} from "./useReviewsHoldoutGatedSetting";

export const useSettingReviewsDisplayGranularRatingsXP = () =>
  useReviewsHoldoutGatedSetting(
    BRAND_REVIEWS_GRANULAR_ATTRIBUTES_DISPLAY_XP_250306,
    false
  );

export const useAssignSettingReviewsDisplayGranularRatingsXPEffect = () =>
  useReviewsHoldoutGatedAssignSettingEffect(
    BRAND_REVIEWS_GRANULAR_ATTRIBUTES_DISPLAY_XP_250306
  );
